/**
 * @generated SignedSource<<cbaab1e940f950519a94f38e30eea25d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProjectVersionStatus = "AWAITING_APPROVAL" | "AWAITING_EVALUATION" | "AWAITING_VALIDATION" | "ERROR" | "OK";
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type SubmissionStatusBadgeFragment$data = {
  readonly evaluation: {
    readonly error: string | null | undefined;
    readonly finalizedAt: DateTime | null | undefined;
    readonly max: boolean;
    readonly score: number | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly project: {
    readonly stage: {
      readonly noCode: boolean;
      readonly showMetric: boolean;
    };
  };
  readonly status: ProjectVersionStatus;
  readonly version: Semver;
  readonly " $fragmentType": "SubmissionStatusBadgeFragment";
};
export type SubmissionStatusBadgeFragment$key = {
  readonly " $data"?: SubmissionStatusBadgeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubmissionStatusBadgeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubmissionStatusBadgeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectVersionEvaluation",
      "kind": "LinkedField",
      "name": "evaluation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "error",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finalizedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "max",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionStage",
          "kind": "LinkedField",
          "name": "stage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showMetric",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "noCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectVersion",
  "abstractKey": null
};

(node as any).hash = "16f9ab180c49626c9da0a8dac59901ad";

export default node;
